import { arrayHasAtLeastOneItem, arrayHasLength, reject } from "../../../../../Common/TypingUtils";

type SpecialKeysString = "Ctrl" | "Alt" | "Shift" | "Ctrl+Shift" | "Alt+Shift" | "Ctrl+Alt" | "Ctrl+Alt+Shift";

type SpecialKeysOrEmpty = `${SpecialKeysString}+` | "";

type KeyString =
    | "A"
    | "B"
    | "C"
    | "D"
    | "E"
    | "F"
    | "G"
    | "H"
    | "I"
    | "J"
    | "K"
    | "L"
    | "M"
    | "N"
    | "O"
    | "P"
    | "Q"
    | "R"
    | "S"
    | "T"
    | "U"
    | "V"
    | "W"
    | "X"
    | "Y"
    | "Z"
    | "F1"
    | "F2"
    | "F3"
    | "F4"
    | "F5"
    | "F6"
    | "F7"
    | "F8"
    | "F9"
    | "F10"
    | "F11"
    | "F12"
    | "ArrowDown"
    | "ArrowUp"
    | "ArrowLeft"
    | "ArrowRight";

export type KeyboardCombinationString = `${SpecialKeysOrEmpty}${KeyString}`;

export enum Key {
    A = "KeyA",
    B = "KeyB",
    C = "KeyC",
    D = "KeyD",
    E = "KeyE",
    F = "KeyF",
    G = "KeyG",
    H = "KeyH",
    I = "KeyI",
    J = "KeyJ",
    K = "KeyK",
    L = "KeyL",
    M = "KeyM",
    N = "KeyN",
    O = "KeyO",
    P = "KeyP",
    Q = "KeyQ",
    R = "KeyR",
    S = "KeyS",
    T = "KeyT",
    U = "KeyU",
    V = "KeyV",
    W = "KeyW",
    X = "KeyX",
    Y = "KeyY",
    Z = "KeyZ",
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    F11 = "F11",
    F12 = "F12",
    ArrowDown = "ArrowDown",
    ArrowUp = "ArrowUp",
    ArrowLeft = "ArrowLeft",
    ArrowRight = "ArrowRight",
}

export enum SpecialKey {
    Ctrl = "Ctrl",
    Alt = "Alt",
    Shift = "Shift",
}

type KeyboardCombination =
    | [Key]
    | [Key, SpecialKey]
    | [Key, SpecialKey, SpecialKey]
    | [Key, SpecialKey, SpecialKey, SpecialKey];

function parseKey(key: KeyString): Key {
    if (key.length === 1) {
        // @ts-ignore
        return "Key" + key;
    }
    // @ts-ignore
    return key;
}

export function parseKeyboardCombination(input: KeyboardCombinationString): KeyboardCombination {
    const keys = input.split("+").map(x => x.trim());
    let mainKey: Key | undefined;
    const specialKeys: SpecialKey[] = [];
    for (const part of keys) {
        if (part === "Ctrl") {
            specialKeys.push(SpecialKey.Ctrl);
        } else if (part === "Alt") {
            specialKeys.push(SpecialKey.Alt);
        } else if (part === "Shift") {
            specialKeys.push(SpecialKey.Shift);
        } else {
            // @ts-ignore
            mainKey = parseKey(part);
        }
    }
    if (
        !arrayHasLength(specialKeys, 0) &&
        !arrayHasLength(specialKeys, 1) &&
        !arrayHasLength(specialKeys, 2) &&
        !arrayHasLength(specialKeys, 3)
    ) {
        throw new Error(`Unable to parse combination ${input}`);
    }
    return [mainKey ?? reject(`Unable to parse combination ${input}`), ...specialKeys];
}

export function isKeyboardCombinationPressed(event: KeyboardEvent, shortcut: KeyboardCombination): boolean {
    const [key, ...specialKeys] = shortcut;
    if (event.code !== key.toString()) {
        return false;
    }
    if (event.ctrlKey !== (arrayHasAtLeastOneItem(specialKeys) && specialKeys.includes(SpecialKey.Ctrl))) {
        return false;
    }
    if (event.altKey !== (arrayHasAtLeastOneItem(specialKeys) && specialKeys.includes(SpecialKey.Alt))) {
        return false;
    }
    if (event.shiftKey !== (arrayHasAtLeastOneItem(specialKeys) && specialKeys.includes(SpecialKey.Shift))) {
        return false;
    }
    return true;
}
